import {
  getBanners,
  setBanner,
  deleteBanner,
} from '@/api';

const localState = {
  banners: [],
};

const actions = {
  // 获取banner图
  fetchBanners(context, { projectId }) {
    getBanners({ projectId }).then((res) => {
      const { banners } = res.data;
      context.commit('setBanners', { banners });
    });
  },
  // 设置项目的banner
  setBanner(context, { projectId, filename }) {
    return new Promise((resolve, reject) => {
      setBanner({ projectId, filename })
        .then((res) => {
          if (res.data.code === 0) {
            const { project } = res.data;
            context.commit('project/updateProject', { project });
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 删除项目banner
  deleteBanner(context, { filename, projectId }) {
    return new Promise((resolve, reject) => {
      deleteBanner({ filename, projectId })
        .then((res) => {
          if (res.data.code === 0) {
            const banners = context.state.banners.filter((banner) => {
              return banner.filename !== filename;
            });
            // 删除了已设置的banner
            if (res.data.delProBanner) {
              context.commit('project/setProBannerNull');
            }
            context.commit('setBanners', { banners });
            resolve();
          }
        })
        .catch(err => reject(err));
    });
  },
};

const mutations = {
  setBanners(state, { banners }) {
    state.banners = banners;
  },
};

export default {
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

